import {MediaCardType} from '@wandb/weave/common/types/media';
import {useCallback} from 'react';

import {Panel} from '../../util/panelTypes';
import {panelViews} from '../PanelBank/types';
import {MediaBrowserPanelConfig} from './common';
import {useGetMediaCardType} from './useGetMediaCardType';

export const SUPPORTED_MEDIA_TYPES: MediaCardType[] = [
  'image',
  'video',
  'audio',
  'object3D',
];
export const useGetIsMediaPanelSettingsDrawerSupportedForPanel = (
  panel: Panel
) => {
  const mediaKeys =
    panel.viewType === panelViews.mediaBrowser
      ? (panel.config as MediaBrowserPanelConfig).mediaKeys
      : undefined;
  const getMediaCardType = useGetMediaCardType(mediaKeys);
  return useCallback(() => {
    const mediaType = getMediaCardType();
    // Only redirect to the media panel settings drawer for supported media panels
    return (
      panel.viewType === panelViews.mediaBrowser &&
      mediaType != null &&
      SUPPORTED_MEDIA_TYPES.includes(mediaType)
    );
  }, [panel, getMediaCardType]);
};
